angular
    .module('WizApp')
    .service('WizDataService', [
        function () {
            return {
                _data: angular.copy(window._wizData || {}),

                get: function (key) {
                    var self = this;

                    return angular.copy(_.get(self._data, key, ''));
                },

                registerDebug: function (name, value) {
                    if (!window) return this;
                    if (!window._wizData) window._wizData = {};
                    if (!window._wizData.__debug) window._wizData.__debug = {};

                    window._wizData.__debug[name] = value;
                    return this;
                }
            };
        }
    ])
;
